import React, {memo, useState, lazy, Suspense, useEffect} from 'react';
import { withTranslation } from "react-i18next";
import qs from 'qs';

const AlignmentSlider = lazy(() => import(
  /* webpackChunkName: "alignmentSlider" */
  "../okr/alignmentSlider"
));
import { okrDetailActions } from '../../actions/okr/okrDetails.actions';
import { okrDetailConstants } from '../../constants/okr/okrDetails.constants';
import { KeyDownEvent } from '../../utils/eventKey';

const OneLineAlignementButtonComp = (props) => {
  const [showSlideShow, setShowSlideShow] = useState(false);
  const [currentSlideDataIndex, setCurrentSlideDataIndex] = useState(0);
  const [refSrc, setRefSrc] = useState('');
  const [sid,setSid] = useState('');
  const [goalsLength,setgoalsLength] = useState(0);
  const triggerAlignmentData = (tempSid) => {
    const {nextAlignment, ...query } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    setShowSlideShow(true);
    props.dispatch({type: okrDetailConstants.RESET_FULL_ALIGNMENT});
    const params = {
      user_search: false, 
      startDate: props.startDate ? props.startDate : "",
      endDate: props.endDate ? props.endDate : "",
      exDate: typeof props.exDate !== 'undefined' ? props.exDate : 1,
      goalStatus: props.status,
      paginate: 1,
      goalLimit: 2
    };
    const sid = tempSid ? tempSid : props.sid;
    let isPersonalOKR = false;
    if (sid && sid.includes('personal-')) {
      params.gType = 2;
      isPersonalOKR = true;
    }
    params.sid = sid?.replace('personal-', '');
    setSid(params.sid);
    searchFullAlignData(params); 
    wb_track('open_one_level_alignment', { email: 'no data' });
    oneLevelAlignmentEventTracker('ONE_LEVEL_ALIGNMENT_VIEWED','TEAM_OKR');
    if (!tempSid) {
      setRefSrc(window.location.href);
      const url = window.location.origin + "/wb/goal/index";
      query.nextAlignment = 1;
      
      if (params.sid && params.sid.includes('team-')) {
        query.teamId = params.sid.replace('team-', '');
      }
      if (props.sid && params.sid.includes('user-')) {
        query.userId = params.sid.replace('user-', '');
        if (isPersonalOKR) {
          query.gType = 2;
        }
      }
      delete query.teamView; 
      windowHistoryPushState(url + '?' + qs.stringify(query, { arrayFormat: 'brackets' }));
    }
    
  }
  useEffect(() => {
    // check if load slider on mount is true and pass the temp id.
    if(props.loadSlideronMount){
      triggerAlignmentData(props.loadSlideronMount);
    }
  }, [])

  const searchFullAlignData = async(params = {}) => {
    if (Object.keys(params).length) {
      showLoaderWidget($("#content"));      
      await props.dispatch(okrDetailActions.getFullAlignData(params));
    }
  }

  const handleButtonClick = (e) => {
    triggerAlignmentData();
  }

  const handleCloseSlider = (e) => {
    setShowSlideShow(false);
    wb_track('close_one_level_alignment', { email: 'no data' });
    const { nextAlignment, ...query } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    console.log('parseUrl 1, parseUrl', nextAlignment)
    if (nextAlignment) {
      console.log("refSRC: "+refSrc)
      if(refSrc && refSrc.length > 0){
        windowHistoryPushState(refSrc);
        setRefSrc('');
      }else{
        console.log(window.location.origin + '/wb/goal/index')
        windowHistoryPushState(window.location.origin + '/wb/goal/index');
      }
      
    }
  }
  
  const prevArrowClick = () => {
    wb_track('shift_previous_one_level_alignment', { email: 'no data' });
    let newDataIndex = currentSlideDataIndex - 1;
    if (newDataIndex < 0) {
      newDataIndex = fullAlignData.goals.length - 1;
    }
    setCurrentSlideDataIndex(newDataIndex);
  }

  const nextArrowClick = () => {
    wb_track('shift_next_one_level_alignment', { email: 'no data' });
    let newDataIndex = currentSlideDataIndex + 1;
    if (newDataIndex > props.fullAlignData.goals.length - 1) {
      newDataIndex = 0;
    }
    
    let offsetVal = props.fullAlignData.goals.length;
    if( offsetVal >= 1 && goalsLength != props.fullAlignData.goals.length){
      const params = {
        user_search: false, 
        startDate: props.startDate ? props.startDate : "",
        endDate: props.endDate ? props.endDate : "",
        exDate: typeof props.exDate !== 'undefined' ? props.exDate : 1,
        goalStatus: props.status,
        paginate: 1,
        goalOffset:offsetVal,
        goalLimit:1,
        sid: sid
      };
      searchFullAlignData(params);
      setgoalsLength(props.fullAlignData.goals.length);
    }
    setCurrentSlideDataIndex(newDataIndex);
  }

  const { fullAlignData , t} = props;

  return (
    <div  className="one-line-alignment" data-testid="one-line-alignment" tabIndex="-1" >
      <div
        aria-label={`${t('View two-level OKR alignment')}`}
        className="one-line-alignment-button"
        data-testid="one-line-alignment-button"
        style={props.style ? {...props.style} : {}}
        onClick={handleButtonClick}
        onKeyDown={(e) => KeyDownEvent(e, () => handleButtonClick(e))}
        role="button"
        tabIndex="0"
        title={`${t('View two-level OKR alignment')}`}
      >
        <span className="icon icon-outline-import_export-24px-2"></span>
      </div>
      {
      showSlideShow && fullAlignData.goals && fullAlignData.goals.length
        ? 
        <div style={{ minHeight: '0px', minWidth: '0px' }}>
          <Suspense fallback={null} >
            <AlignmentSlider
              slideData={fullAlignData.goals}
              currentSlideDataIndex={currentSlideDataIndex}
              closeSlider={handleCloseSlider}
              prevArrowClick={prevArrowClick}
              nextArrowClick={nextArrowClick}
            />
          </Suspense>
        </div>
        : ''
      }
    </div>
  );
}


export default withTranslation()(OneLineAlignementButtonComp);
